export default __webpack_public_path__ + "static/media/hackathon.89e242df.png";